<template>
    <div class="p-1">
        <div-table :config="configList" :data="orders" :statusShippChange="statusShippChange"
            :statusOrder="statusOrderU" :zones="zones" :element="element" @reset="reset" @refresh="refresh"
            @showProducts="showProducts" @filtrer="filtrer" @Changelimit="Changelimit" :limit="limit"
            @downloadOrders="downloadOrders" @search="search" :loading="loading" :paginate="paginate"
            @paginatation="paginatation" @CheckQteDefecteuseOrder="CheckQteDefecteuseOrder"
            :CheckQteDefecteuseorderexist="CheckQteDefecteuseorderexist" @selectAllCheckbox="selectAllCheckbox"
            @getRowDetail="getRowDetail" :tabId="tabId" @emtyTabId="emtyTabId" @searchSellers="searchSellers">
        </div-table>
    </div>
</template>

<script>
import config from './config';
export default {
    data() {
        return {
            configList: config.list,
            loading: false,
            CheckQteDefecteuseorderexist: false,
            orders: [],
            element: {},
            sellers: [],
            show_modal: false,
            limit: 50,
            arrayScv: [],
            filters: {},
            statusOrder: [],
            statusOrderU: [],
            zones: [],
            products: [],
            currentUser: {},
            idWharhouse: '',
            tabId: [],
            cities: [],
            statusShippChange: [],
            formData: {
                customer: {},
            },
            paginate: {
                total: 0,
                currentpage: 1,
                lastpage: 0,
                per_page: 0,
            },
            shippingStatus: [
                'to prepare',
                'prepared',
                'shipped',
                'delivered',
                'paid',
                'processed',
                'rembourser',
                'cancelled',
                'refused',
                'postponed',
                'unreachable',
                'return',
                'echange',
                'picked up',
                'reprogram',
                'interested'
            ]
        };
    },
    async mounted() {
        await this.getUser();
        await this.getwharhouseId();
        await this.getStatus();

        if (this.currentUser.type == 'Seller') {
            let pos = this.configList.columns.map(function (e) { return e.name }).indexOf('seller');
            if (pos != -1) this.configList.columns.splice(pos, 1);

            let posW = this.configList.columnsDialog.elements.map(function (e) { return e.name }).indexOf('warehouse');
            if (posW != -1) this.configList.columnsDialog.elements.splice(posW, 1);

            let pos_1 = this.configList.columns.map(function (e) { return e.type; }).indexOf('checkbox');
            if (pos_1 != -1) this.configList.columns.splice(pos_1, 1);

            this.configList.options.actions.buttons = this.configList.options.actions.buttons.filter(e => e.action !== 'changestatus');
        }
        
        if(this.currentUser.type == 'Seller' || this.currentUser.type === 'TeleConsultant') {
            let positionShipper = this.configList.columns.map(function (e) { return e.name }).indexOf('shipper');
            if (positionShipper != -1) this.configList.columns.splice(positionShipper, 1);
        }

        if (this.$f.QueryStringToobject()) {
            this.filters = this.$f.QueryStringToobject();
        } else {
            this.$f.objectToQueryString({
                limit: this.limit,
                'customer.country': await this.warhouseSelected,
            });
        }

        if (this.currentUser.type === 'TeleConsultant') {
            delete this.configList.filters.elements.champs;
        }

        this.filters = this.$f.QueryStringToobject();
        if (this.filters.name) {
            await this.search(this.filters.name);
        } else {
            await this.getOrders(this.filters);
        }

        await this.getZones();
        if (this.currentUser.type !== 'Seller') {
            await this.getProducts();
            this.setDataSelect('product', this.products, null);
            
            await this.getSellers();
            this.setDataSelect('seller', this.sellers, null);
        }

        this.setDataSelect('shippingStatus', this.shippingStatus, null);
        this.setDataSelect('status', this.statusOrder, null);
        this.setDataSelect('city', this.statusOrder, null);

        this.setDataSelect('status_pending', [
            { name: 'pending' },
            { name: 'pending_unrached' },
            { name: 'pending_remind' },
        ], null);

        this.setDataSelect('upsel', ['oui', 'non'], null);
        await this.getCities(await this.warhouseSelected);

        this.setDataSelect('city', this.cities, null);
    },
    computed: {
        warhouseSelected() {
            return this.$store.getters['wharhouse/warhouseSelected'];
        },
    },
    watch: {
        warhouseSelected: async function (oldVal, newVal) {
            await this.reset();

            if (this.currentUser.type != 'Seller') {
                await this.getSellers();
                await this.getProducts();
                await this.getZones();
                this.setDataSelect('seller', this.sellers, null);
            }
        },
    },
    methods: {
        async getCities(country) {
            const resCities = await this.$server.get('zones', {
                allCities: true,
                country: country,
            });
            if (resCities.content.length > 0) this.cities = resCities.content;
            else this.cities = [];
        },
        selectAllCheckbox($event) {
            let columns = document.querySelectorAll('.rowCheckbox');

            this.tabId = [];
            if ($event.target.checked) {
                columns.forEach(column => {
                    column.checked = true;
                    this.tabId.push({
                        order: JSON.parse(column.getAttribute('orderObjet')),
                    });
                });
            } else {
                columns.forEach(column => {
                    column.checked = false;
                });
                this.tabId = [];
            }
            console.log('selectAllCheckbox - tabId:', this.tabId);
        },
        getRowDetail(item, id) {
            let columns = document.querySelectorAll('.rowCheckbox'); // Add this line

            let itemInRow = this.tabId.filter(
                item => item.order && item.order._id.toString() == id.toString(),
            );

            let isItemInRow = itemInRow.length > 0;

            if (isItemInRow) {
                let pos = this.tabId
                    .map(function (e) {
                        return e.order._id;
                    })
                    .indexOf(id);
                this.tabId.splice(pos, 1);
            } else {
                this.tabId.push({ order: item });
            }

            // Update the "select all" checkbox state
            let selectAllCheckbox = document.querySelector('.checkallbbox');
            if (this.tabId.length === columns.length) {
                selectAllCheckbox.checked = true;
            } else {
                selectAllCheckbox.checked = false;
            }
            console.log('getRowDetail - tabId:', this.tabId);
        },
        emtyTabId() {
            let columns = document.querySelectorAll('.rowCheckbox');
            columns.forEach(column => {
                column.checked = false;
            });
            this.tabId = [];
        },
        async getwharhouseId() {
            await this.$store.dispatch('wharhouse/getwharhouseId').then(res => {
                this.idWharhouse = res;
            });
        },
        async Changelimit(val) {
            if (this.$f.QueryStringToobject()) {
                this.filters = this.$f.QueryStringToobject();
            }

            this.filters['limit'] = val;
            this.filters['page'] = 1;
            this.paginate.currentpage = 1;

            this.$f.objectToQueryString(this.filters);
            if (this.filters.name) await this.search(this.filters.name);
            else this.getOrders(this.filters);
        },
        sumProduct(data) {
            let product = '';
            for (let i in data) {
                product += data[i].product.name;
                if (data.length - 1 != i) product += ' ,';
            }
            return product;
        },
        async downloadOrders() {
            this.arrayScv = typeof this.orders !== 'object' ? JSON.parse(this.orders) : this.orders;
            for (let i in this.arrayScv) {
                this.arrayScv[i].IdOrder = this.arrayScv[i].id.replace('#', '');
                this.arrayScv[i].Seller = this.arrayScv[i].seller.fullName;
                this.arrayScv[i].Customer = this.arrayScv[i].customer.fullName;
                this.arrayScv[i].Phone = this.arrayScv[i].customer.phone;
                this.arrayScv[i].Products = this.sumProduct(this.arrayScv[i].details);
                this.arrayScv[i].ShippingAddress = this.arrayScv[i].customer
                    .shippingAddress ? this.arrayScv[i].customer.shippingAddress : '';
                this.arrayScv[i].TotalPrice = this.arrayScv[i].totalPrice;
                this.arrayScv[i].OrderDate = this.$moment(this.arrayScv[i].date).format(
                    'yyyy-MM-DD HH:mm',
                );
                this.arrayScv[i].Status = this.arrayScv[i].status.name;
            }

            for (let j in this.arrayScv) {
                delete this.arrayScv[j].statusCallcenter;
                delete this.arrayScv[j].teleConsultantConfirm;
                delete this.arrayScv[j].lastUnreachedDate;
                delete this.arrayScv[j].updatedAt;
                delete this.arrayScv[j].sameOrderUnreached;
                delete this.arrayScv[j].random;
                delete this.arrayScv[j].unreachedBy;
                delete this.arrayScv[j].totalPrice;
                delete this.arrayScv[j]._id;
                delete this.arrayScv[j].totalFees;
                delete this.arrayScv[j].teleConsultant;
                delete this.arrayScv[j].status;
                delete this.arrayScv[j].source;
                delete this.arrayScv[j].seller;
                delete this.arrayScv[j].processedPrice;
                delete this.arrayScv[j].processedAt;
                delete this.arrayScv[j].paidAt;
                delete this.arrayScv[j].isRefunded;
                delete this.arrayScv[j].isDeleted;
                delete this.arrayScv[j].details;
                delete this.arrayScv[j].date;
                delete this.arrayScv[j].customer;
                delete this.arrayScv[j].createdAt;
                delete this.arrayScv[j].comment;
                delete this.arrayScv[j].skippedBy;
                delete this.arrayScv[j].id;
                delete this.arrayScv[j].isReminded;
                delete this.arrayScv[j].postponed;
                delete this.arrayScv[j].remindBy;
                delete this.arrayScv[j].__v;
            }

            let str = `${Object.keys(this.arrayScv[0]).map(value => `"${value}"`).join(',')}` + '\r\n';
            let csvContent = this.arrayScv.reduce((st, next) => {
                st += `${Object.values(next).map(value => `"${value}"`).join(',')}` + '\r\n';
                return st;
            }, str);

            let element = document.createElement('a');
            element.href = 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURI(csvContent);
            element.target = '_blank';
            element.download = 'orders.csv';
            element.click();
        },
        sumQteProduct(data) {
            let sum = 0;
            for (let i in data) {
                sum = sum + data[i].quantity;
            }
            return sum;
        },
        setDataSelect(model, data, splice) {
            for (var i = 0; i < this.configList.filters.elements.champs.length; i++) {
                if (
                    this.configList.filters.elements.champs[i].type === 'select' &&
                    this.configList.filters.elements.champs[i].key === model
                ) {
                    if (!splice) {
                        this.configList.filters.elements.champs[i].values = data;
                    } else {
                        this.configList.filters.elements.champs.splice(i, 1);
                    }
                }
            }
        },
        async getStatusByName(name) {
            const result = await this.$server.get('status', { name: name });
            return result.content._id;
        },
        async getStatusByNameV2(name) {
            const result = await this.$server.get('status', { name: name });
            return result.content;
        },
        async CheckQteDefecteuseOrder(item) {
            this.CheckQteDefecteuseorderexist = false;

            if (item.status && item.status.name == 'Return') {
                for (let i in item.details) {
                    const filters = {
                        product: item.details[i].product._id,
                        order: item._id,
                        shipping: null,
                    };
                    const res = await this.$server.search('stockHistories', filters);

                    if (typeof res.content.results !== 'undefined') {
                        item.details[i].product.qteChange = res.content.results[0].quantity;
                        this.CheckQteDefecteuseorderexist = true;
                    }
                }
            }
        },
        searchSellers: _.debounce(async function(search, event) {
            const filter = {
                type: 'Seller',
                limit: this.limit,
                countries: await this.warhouseSelected,
                name: search,
            };

            const res = await this.$server.find('users', filter);

            if (res && res.content.results) this.sellers = res.content.results;
            else this.sellers = [];
            this.setDataSelect('seller', this.sellers, null);
        }, 500),
        async getSellers() {
            const filter = {
                type: 'Seller',
                countries: await this.warhouseSelected,
                limit: 16
            };
            if (this.currentUser.type != 'Seller') {
                const res = await this.$server.search('users', filter);
                if (res && res.content.results) this.sellers = res.content.results;
                else this.sellers = [];
            }
        },
        async getProducts() {
            const filter = {
                'details.warehouse': this.idWharhouse._id,
            };

            const res = await this.$server.search('products', filter);

            if (res.content.results) this.products = res.content.results;
            else this.products = [];
        },
        async reset(data) {
            let lmitt = this.limit;
            if (this.$f.QueryStringToobject())
                this.filters = this.$f.QueryStringToobject();
            if (this.filters['limit']) lmitt = this.filters['limit'];
            this.filters['page'] = 1;
            this.$f.objectToQueryString({
                limit: lmitt,
                'customer.country': await this.warhouseSelected,
            });
            await this.getOrders({
                limit: lmitt,
                'customer.country': await this.warhouseSelected,
            });
        },
        async filtrer(data) {
            if (this.$f.QueryStringToobject()) {
                this.filters = this.$f.QueryStringToobject();
            }

            this.filters['customer.city'] = data.city;
            delete this.filters.page;
            delete this.filters.IsFilter;

            delete this.filters.name;
            delete this.filters.country;

            this.filters['customer.country'] = await this.warhouseSelected;
            if (!this.filters['limit']) this.filters['limit'] = this.limit;

            if (data.Range_date) {
                this.filters.Range_date = data.Range_date.map(el => this.$moment(el).format('yyyy-MM-DD'));
            } else delete this.filters.Range_date;

            if (data.from && data.to) {
                delete this.filters.date;
                this.filters.from = data.from;
                this.filters.to = data.to;
            } else {
                delete this.filters.from;
                delete this.filters.to;
            }

            if (data.upsel) this.filters.upsel = data.upsel;
            else delete this.filters.upsel;

            this.paginate.currentpage = 1;

            if (data.seller) this.filters.seller = data.seller._id;
            else delete this.filters.seller;

            if (data.affiliate_stores) this.filters.ThirdParty = data.affiliate_stores;
            else delete this.filters.ThirdParty;

            if (data.product) this.filters['details.product'] = data.product._id;
            else delete this.filters['details.product'];

            if (data.shippingStatus) this.filters.shippingStatus = data.shippingStatus;
            else delete this.filters.shippingStatus;

            if (data.status) this.filters.status = data.status._id;
            else delete this.filters.status;

            if (data.status_pending)
                this.filters.status_pending = data.status_pending.name;
            else delete this.filters.status_pending;

            if (data.totalPrice) this.filters.totalPrice = data.totalPrice;
            else delete this.filters.totalPrice;

            this.$f.objectToQueryString(this.filters);

            await this.getOrders(this.filters);
        },
        async getUser() {
            const res = await this.$me;
            this.currentUser = res.content;
        },
        async getStatus() {
            const statusNames = [
                'Confirmed', 'Cancelled', 'Unreached', 'Pending', 'OutOfStock',
                'Fulfill OutOfStock', 'To fulfill', 'multi order', 'not valid', 'wrong number'
            ];

            const [ idCo, idC, idU, Pe, Ou, OuF, Aw, Dou, NV, WN] = await Promise.all(
                statusNames.map(name => this.getStatusByNameV2(name))
            );

            const pending_unreached = { _id: Pe._id, name: 'pending_unreached', color: Pe.color };
            const Re = { _id: Pe._id, name: 'ToRemind', color: Pe.color };

            let Skp = null;
            if (this.currentUser.type !== 'Seller') {
                Skp = { _id: "skipped", name: "Skipped" };
            }

            this.statusOrder = [Pe, Ou, OuF, idCo, idC, idU, Aw, Dou, NV, WN, Skp].filter(Boolean);
            this.statusOrderU = [Pe, pending_unreached, Re, Ou, OuF, idCo, idC, idU, Aw, Dou, NV, WN];
            this.statusShippChange = [Ou, Pe, idCo];
        },
        async getZones() {
            if (this.currentUser.type != 'Seller') {
                const res = await this.$server.search('zones', { limit: 1000, country: await this.warhouseSelected });
                if (res.content.results) this.zones = res.content.results;
                else this.zones = [];
            } else {
                this.zones = [];
            }
        },
        async assign(index) {
            if (!this.orders[index].teleConsultant) {
                this.orders[index].teleConsultant = this.currentUser._id;
                const res = await this.$server.update('orders', this.orders[index]);
            }
        },
        getAccess(modelToCheck, accessToCheck) {
            const permissions = this.currentUser.role.permissions;
            for (let i in permissions) {
                let model = permissions[i]['model'];
                let access = permissions[i]['access'];
                if (model == modelToCheck) {
                    return access[accessToCheck];
                }
            }
        },
        async refresh() {
            if (this.$f.QueryStringToobject())
                this.filters = this.$f.QueryStringToobject();
            this.$f.objectToQueryString(this.filters);

            if (this.filters.name) await this.search(this.filters.name);
            else await this.getOrders(this.filters);
            if (
                this.filters['page'] &&
                this.filters['page'] > 1 &&
                this.orders.length == 0
            ) {
                this.filters['page'] = --this.filters['page'];
                this.$f.objectToQueryString(this.filters);
                await this.getOrders(this.filters);
            }
        },
        showProducts(index) {
            if (this.element !== this.orders[index]) {
                this.element = this.orders[index];
                //
            } else this.element = null;
        },
        async getOrders(filters) {
            this.loading = true;

            try {
                document.querySelectorAll('.rowCheckbox').forEach(checkbox => checkbox.checked = false);

                this.tabId = [];
                filters['customer.country'] = await this.warhouseSelected;

                if (!filters['customer.city'] || filters['customer.city'] === "undefined") {
                    delete filters['customer.city'];
                }

                const res = await this.$server.search('orders', filters);
                const orders = res.content && res.content.results ? res.content.results : [];

                this.orders = orders.map(order => {
                    if (order.details) {
                        order.details.forEach(detail => {
                            if (detail && detail.unitPrice) {
                                detail.unitPrice = detail.unitPrice.toFixed(2);
                            }
                        });
                    }
                    return order;
                });

                await this.getShippingStatus();

                const { total, last_page, per_page, current_page } = res.content;
                this.paginate = { total, lastpage: last_page, per_page, currentpage: current_page };
            } catch (error) {
                this.orders = [];
                this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };
            } finally {
                this.loading = false;
            }
        },
        async search(data) {
            this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };

            const limit = this.filters['limit'] || this.limit;
            const searchParams = {
                name: data.trim(),
                limit: parseInt(limit),
                country: await this.warhouseSelected,
            };

            this.$f.objectToQueryString(searchParams);

            try {
                const res = await this.$server.find('orders', searchParams);

                if (res.content && res.content.results) {
                    this.orders = res.content.results;

                    await this.getShippingStatus();

                    const { total, last_page, per_page, current_page } = res.content;
                    this.paginate = { total, lastpage: last_page, per_page, currentpage: current_page };
                } else {
                    this.orders = [];
                    this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };
                }
            } catch (error) {
                console.error("Error fetching orders:", error);
                this.orders = [];
                this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };
            }
        },
        async getShippingStatus() {
            const orderIds = this.orders
                .filter(({ status }) => status && ["To fulfill", "Confirmed"].includes(status.name))
                .map(({ _id }) => _id);

            if (orderIds.length === 0) return;

            const { content: { results: shippings = [] } = {} } = await this.$server.search('shippings', { ids: orderIds, limit: 300 });

            const shippingStatusMap = shippings.reduce((map, { order, status, trackingNumber, orderObjet }) => {
                if (order && order._id && status && trackingNumber && orderObjet) {
                    map[order._id] = { status, trackingNumber, teleConsultantConfirm: orderObjet.teleConsultantConfirm };
                }
                return map;
            }, {});

            this.orders.forEach(order => {
                const shippingData = shippingStatusMap[order._id];
                if (shippingData) {
                    const { status, trackingNumber, teleConsultantConfirm } = shippingData;
                    order.trackingNumber = trackingNumber;
                    order.shippingStatus = this.formatShippingStatus(status, teleConsultantConfirm);
                }
            });
        },
        formatShippingStatus(status, confirm) {
            const statusColors = {
                'to prepare': '#e99313',
                'prepared': '#08c2e2',
                'shipped': '#6a4709',
                'delivered': '#3ad912',
                'paid': '#c2a81b',
                'processed': '#d71ae6',
                'cancelled': '#ff0505',
                'refused': '#ff0505',
                'postponed': '#e381d2',
                'rembourser': '#080808',
                'unreachable': '#8d0876',
                'pending return': '#e381d2',
                'return': '#8d0876',
                'reprogram': '#317873',
                'interested': '#1e90ff',
                'picked up': '#4b0082',
            };

            const color = statusColors[status] || '#000';
            const statusLabel =
                `<span style="background-color: ${color}; border-color: ${color};" class="text-white text-xs font-medium border-2 border-solid rounded-full px-6 py-1">
                    ${status}
                </span>`;

            const confirmLabel = confirm && this.currentUser.type !== 'Seller' ?
                `<span class="flex items-center justify-center gap-1 border-2 border-dashed border-gray-800 text-gray-800 rounded-md px-2">
                    <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M3.848 19h-.848c-.796 0-1.559-.316-2.121-.879-.563-.562-.879-1.325-.879-2.121v-3c0-7.175 5.377-13 12-13s12 5.825 12 13v3c0 .796-.316 1.559-.879 2.121-.562.563-1.325.879-2.121.879h-.848c-2.69 4.633-6.904 5-8.152 5-1.248 0-5.462-.367-8.152-5zm16.152-5.876c-.601.236-1.269-.18-1.269-.797 0-.304-.022-.61-.053-.915-1.761-.254-3.618-1.926-3.699-3.723-1.315 2.005-4.525 4.17-7.044 4.17 1.086-.699 1.839-2.773 1.903-3.508-.581 1.092-2.898 3.136-4.551 3.487l-.018.489c0 .619-.669 1.032-1.269.797v3.771c.287.256.632.464 1.041.594.225.072.412.224.521.424 2.206 4.046 5.426 4.087 6.438 4.087.929 0 3.719-.035 5.877-3.169-1.071.433-2.265.604-3.759.653-.37.6-1.18 1.016-2.118 1.016-1.288 0-2.333-.784-2.333-1.75s1.045-1.75 2.333-1.75c.933 0 1.738.411 2.112 1.005 1.9-.026 4.336-.334 5.888-2.645v-2.236zm-11-.624c.686 0 1.243.672 1.243 1.5s-.557 1.5-1.243 1.5-1.243-.672-1.243-1.5.557-1.5 1.243-1.5zm6 0c.686 0 1.243.672 1.243 1.5s-.557 1.5-1.243 1.5-1.243-.672-1.243-1.5.557-1.5 1.243-1.5zm5.478-1.5h1.357c-.856-5.118-4.937-9-9.835-9-4.898 0-8.979 3.882-9.835 9h1.357c.52-4.023 3.411-7.722 8.478-7.722s7.958 3.699 8.478 7.722z" fill="currentColor"></path>
                    </svg>
                    <span>${confirm.fullName}</span>
                </span>` : '';

            return `<div class='flex flex-col gap-2'>${statusLabel}${confirmLabel}</div>`;
        },
        async remove(id) {
            this.$confirm(this.$t('confirm_delete_order')).then(async res => {
                if (res) {
                    const resp = await this.$server.delete('orders', { id: id });
                    await this.refresh();
                    alert(this.$t('order_deleted'), 'success');
                }
            });
        },
        async paginatation(direction) {
            var page = 0;
            if (direction == 'next') {
                page = ++this.paginate.currentpage;
            } else {
                page = --this.paginate.currentpage;
            }

            if (this.$f.QueryStringToobject())
                this.filters = this.$f.QueryStringToobject();
            this.filters['page'] = page;
            this.$f.objectToQueryString(this.filters);

            this.getOrders(this.filters);
            let columns = document.querySelectorAll('.rowCheckbox');
            columns.forEach(column => {
                column.checked = false;
            });
            this.tabId = [];
        }
    },
};
</script>

<style>
/* animation for vue transition tag */

dialog[open] {
    animation: appear 0.15s cubic-bezier(0, 1.8, 1, 1.8);
}

dialog::backdrop {
    background: linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(54, 54, 54, 0.5));
    backdrop-filter: blur(3px);
}

@keyframes appear {
    from {
        opacity: 0;
        transform: translateX(-3rem);
    }

    to {
        opacity: 1;
        transform: translateX(0);
    }
}

/**********************************Table Product PopUp ***************************/

@media (min-width: 640px) {
    thead tr:not(:first-child) {
        display: none;
    }
}

td:not(:last-child) {
    border-bottom: 0;
}

th:not(:last-child) {
    border-bottom: 2px solid rgba(0, 0, 0, 0.1);
}
</style>
